<!--
  Upsell grid only — the "Need more Fun?" heading lives in checkout.component.html's
  shared top row, so this grid (the left column's first card row) starts flush
  with the column top and aligns with the Order Summary stack across columns.
-->
<div
  id="group-outing"
  class="flex flex-col justify-start w-full h-full max-h-fit">
  <div class="gap-3 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 w-full">
    @for (upsell of transaction().transaction.event?.upsells; track upsell.id) {
      <app-upsell-toggle-card
        [upsell]="upsell"
        [checked]="
          upsellSelected !== null && upsell.id === upsellSelected()?.id
        "
        [disabled]="isUpsellDisabled(upsell)"
        [disabledTooltip]="'Not available while a discount code is active'"
        (toggled)="onChangeUpsell($event)" />
    }
  </div>
</div>
